import React from 'react';
import EntryIcon from './EntryIcon';
import {TYPE_LABELS} from '../entryTypes';

const RecordButton = ({type, variant = 'primary', onClick, isSaving}) => (
    <button
        className={`record-button record-button-${variant} record-button-${type} ${isSaving ? 'saving' : ''}`}
        onClick={onClick}
        disabled={isSaving}
        aria-busy={isSaving}
    >
        <EntryIcon type={type} className="record-button-icon"/>
        <span className="record-button-label">
            {isSaving ? 'Saving…' : `Record ${TYPE_LABELS[type]}`}
        </span>
    </button>
);

export default RecordButton;
